import firebase from "firebase/compat/app"
import "firebase/compat/firestore"

const firebaseConfig = {
  apiKey: "AIzaSyArj34jJ1WxjQAAXVhpvb8NxUYvrKFwiyI",
  authDomain: "pinput-2c49b.firebaseapp.com",
  projectId: "pinput-2c49b",
  storageBucket: "pinput-2c49b.appspot.com",
  messagingSenderId: "246128280902",
  appId: "1:246128280902:web:bf53173eb5529bb63b1147"
};


const app = firebase.initializeApp(firebaseConfig);

const db = app.firestore();


export default db
